const HotelOwner = 'HotelOwner';
const PaymentProfile = 'PaymentProfile';
const SupplierHotelRoomType = 'SupplierHotelRoomType';
const SystemUser = 'SystemUser';
const TimeZoneUtil = 'TimeZoneUtil';
const SupplierHotel = 'SupplierHotel';
const Hotel = 'Hotel';
const SupplierHotelRatePlan = 'SupplierHotelRatePlan';
const SupplierHotelMealPlan = 'SupplierHotelMealPlan';
const SupplierTax = 'SupplierTax';
const SupplierSupplement = 'SupplierSupplement';
const SupplierBooking = 'SupplierBooking';
const City = 'City';
const Country = 'Country';
const SupplierBookingStatusType = 'SupplierBookingStatusType';
const OwnerType = 'OwnerType';
const InvoiceReceivingMethodType = 'InvoiceReceivingMethodType';
const BedType = 'BedType';
const HotelType = 'HotelType';
const HotelCategory = 'HotelCategory';
const HotelChain = 'HotelChain';
const Currency = 'Currency';
const Province = 'Province';
const Region = 'Region';
const ServiceType = 'ServiceType';
const ServiceCategory = 'ServiceCategory';
const HostSegment = 'HostSegment';
const MealPlanType = 'MealPlanType';
const HotelImageType = 'HotelImageType';
const ContentLanguage = 'ContentLanguage';
const DestinationTaxType = 'DestinationTaxType';
const DestinationTaxScope = 'DestinationTaxScope';
const SupplierBookingStatus = 'SupplierBookingStatus';
const PaymentProfileHotelOwner = 'PaymentProfileHotelOwner';
const AccountManagementSegment = 'AccountManagementSegment';
const Agency = 'Agency';
const ZinantisRelationshipStatusType = 'ZinantisRelationshipStatusType';
const ChannelManager = 'ChannelManager';
const ChannelManagerStatus = 'ChannelManagerStatus';
const ChannelManagerStatusType = 'ChannelManagerStatusType';
const ExternalIntegrationType = 'ExternalIntegrationType';
const ZinantisConnectionRequest = 'ZinantisConnectionRequest';
const ZinantisConnectionRequestStatus = 'ZinantisConnectionRequestStatus';
const ZinantisConnectionRequestStatusType =
    'ZinantisConnectionRequestStatusType';
const LogoFile = 'LogoFile';
const SupplementCalculationType = 'SupplementCalculationType';
const SupplierTaxCalculationRuleType = 'SupplierTaxCalculationRuleType';
const SupplierTaxCalculationType = 'SupplierTaxCalculationType';
const SupplierTaxType = 'SupplierTaxType';
const Application = 'Application';
const ApplicationConfiguration = 'ApplicationConfiguration';
const ApplicationConfigurationKey = 'ApplicationConfigurationKey';
const StaticRateContract = 'StaticRateContract';
const RateScopeModel = 'RateScopeModel';
const StaticRateContractStatusType = 'StaticRateContractStatusType';
const StaticRateContractStatus = 'StaticRateContractStatus';
const SupplierHotelStopSale = 'SupplierHotelStopSale';
const AgencyHotelRelationship = 'AgencyHotelRelationship';
const ZitoneoPublishStatusType = 'ZitoneoPublishStatusType';
const ServiceExceptionLevelType = 'ServiceExceptionLevelType';
const ZitoneoHotelUrl = 'ZitoneoHotelUrl';
const ChildrenAgeSegment = 'ChildrenAgeSegment';
const AttributeDefinition = 'AttributeDefinition';
const ZitoneoScrapingExecution = 'ZitoneoScrapingExecution';
const Alert = 'Alert';

export const savableEntities = {
    HotelOwner,
    PaymentProfile,
    SupplierHotelRoomType, // se guarda con commonSave Y con /api/common/deleteItems
    SystemUser,
    SupplierHotel, // no se guada con common/save pero sí con SaveSupplierHotelFromWizard
    SupplierTax,
    SupplierSupplement,
    SupplierHotelStopSale,
    StaticRateContract,
    Hotel,
};

export const readOnlyEntities = {
    // tipologías o combos
    TimeZoneUtil,
    City,
    SupplierBookingStatusType,
    Country,
    OwnerType,
    InvoiceReceivingMethodType,
    BedType,
    HotelType,
    HotelCategory,
    HotelChain,
    Currency,
    Region,
    ServiceCategory,
    Province,
    ServiceType,
    HostSegment,
    MealPlanType,
    HotelImageType,
    ContentLanguage,
    DestinationTaxType,
    DestinationTaxScope,
    AccountManagementSegment,
    Agency,
    ZinantisRelationshipStatusType,
    ChannelManager,
    ChannelManagerStatus,
    ChannelManagerStatusType,
    ExternalIntegrationType,
    StaticRateContract,
    RateScopeModel,
    StaticRateContractStatus,
    StaticRateContractStatusType,
    ChildrenAgeSegment,
    // específicas para el IdHotelOwner
    SupplierHotel,
    SupplierHotelRoomType,
    SupplierHotelRatePlan,
    SupplierHotelMealPlan,
    SupplierTax,
    SupplierSupplement,
    SupplierBooking,
    Hotel,
    SupplierBookingStatus,
    PaymentProfileHotelOwner,
    ZinantisConnectionRequest,
    ZinantisConnectionRequestStatus,
    ZinantisConnectionRequestStatusType,
    LogoFile,
    SupplementCalculationType,
    SupplierTaxCalculationRuleType,
    SupplierTaxCalculationType,
    SupplierTaxType,
    SupplierHotelStopSale,
    AgencyHotelRelationship,
    // configuración
    Application,
    ApplicationConfiguration,
    ApplicationConfigurationKey,
    //zitoneo
    ZitoneoPublishStatusType,
    AttributeDefinition,
    ServiceExceptionLevelType,
    ZitoneoHotelUrl,
    ZitoneoScrapingExecution,
    Alert,
};

export const viewModelEntities = {
    HotelOwner,
    PaymentProfile,
    SupplierBooking,
    SystemUser,
    SupplierHotelRoomType,
    Agency,
    SupplierTax,
    SupplierHotel,
    SupplierSupplement,
    SupplierHotelStopSale,
    StaticRateContract,
};
